import { ButtonSecondary } from '../../baseComponents/Button'
import TwinTrans from '../../baseComponents/TwinTrans'

interface ButtonChangeToStatusViewProps {
    onClick: () => void
    className?: string
}

export const ButtonChangeToStatusView: React.FC<ButtonChangeToStatusViewProps> = ({ onClick, className }) => {
    return (
        <ButtonSecondary className={(className || '')} onClick={onClick}>
            <TwinTrans transKey='changeView'>Cambiar vista</TwinTrans>
        </ButtonSecondary>
    )
}